(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || window.mbRuntime?.root || '/';
  let products = {};
  let busy = false;
  const selections = new Map();
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: window.mbRuntime?.currency || 'USD'
  }).format(Number(cents) / 100);
  const getProducts = () => {
    if (!Object.keys(products).length) {
      try { products = JSON.parse(document.querySelector('#mb-products')?.textContent || '{}'); }
      catch { products = {}; }
    }
    return products;
  };
  const bundleProperties = (variant, existing = {}) => {
    const properties = {...existing};
    const units = {'Buy 1':1,'Buy 2 Get 1 Free':3,'Buy 3 Get 2 Free':5}[variant?.title];
    const label = '_Bottles per bundle / Flacons par lot';
    if (units) properties[label] = String(units);
    else delete properties[label];
    return properties;
  };
  const error = (message, anchor) => {
    let target = document.querySelector('cart-drawer.active .mcd-err');
    if (!target && anchor) {
      target = anchor.parentElement.querySelector('.mb-commerce-error');
      if (!target) { target = document.createElement('p'); target.className = 'mb-commerce-error'; target.setAttribute('role', 'alert'); anchor.after(target); }
    }
    if (target) { target.hidden = false; target.textContent = message; }
  };
  const request = async (path, payload) => {
    const response = await fetch(root + path, {
      method: payload ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', ...(payload ? {'Content-Type':'application/json'} : {}) },
      ...(payload ? {body:JSON.stringify(payload)} : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  };
  class MetabolaeCart extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', event => {
        if (event.target.id === 'CartDrawer-Overlay' || event.target.closest('.drawer__close')) this.close();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.close();
        if (event.key === 'Tab' && this.classList.contains('active')) {
          const controls = [...this.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select')].filter(x=>x.offsetParent!==null);
          const first=controls[0],last=controls.at(-1);
          if (event.shiftKey && document.activeElement===first) {event.preventDefault();last?.focus();}
          else if (!event.shiftKey && document.activeElement===last) {event.preventDefault();first?.focus();}
        }
      });
    }
    open(trigger) { this.trigger=trigger||document.activeElement; this.classList.add('active'); document.body.classList.add('mb-cart-open'); this.querySelector('.drawer__close')?.focus(); }
    close() { this.classList.remove('active'); document.body.classList.remove('mb-cart-open'); this.trigger?.focus?.(); }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', MetabolaeCart);
  const refreshCart = async (open, trigger) => {
    const [sections, cart] = await Promise.all([
      request('?sections=cart-drawer'), request('cart.js')
    ]);
    const parsed = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
    let updated = parsed.querySelector('cart-drawer'); if (!updated) { const page = await fetch(location.pathname + location.search, {credentials:'same-origin',headers:{Accept:'text/html'}}); const markup = await page.text(); updated = new DOMParser().parseFromString(markup,'text/html').querySelector('cart-drawer'); }
    const drawer = document.querySelector('cart-drawer');
    if (!updated || !drawer) throw new Error('Please refresh your cart and try again.');
    drawer.innerHTML = updated.innerHTML;
    drawer.classList.toggle('is-empty', cart.item_count===0);
    const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) {bubble.textContent=cart.item_count; bubble.hidden=cart.item_count===0;}
    if (open) drawer.open(trigger);
    document.dispatchEvent(new CustomEvent('mb:cart:updated',{detail:cart}));
    return cart;
  };
  const widgetFor = anchor => anchor?.closest('[data-mb-bundles]') || document.querySelector('[data-mb-bundles]');
  const selected = anchor => {
    const widget=widgetFor(anchor);
    const p=getProducts()[widget?.dataset.productHandle] || getProducts()[window.mbPrimaryHandle || 'softgels-ceylon'];
    if (!p?.variants?.length) throw new Error('This product is currently unavailable.');
    let state=selections.get(widget) || {index:Math.min(1,p.variants.length-1),subscribe:!!widget?.querySelector('[data-mb-plan]')};
    const variant=p.variants[state.index];
    const plan=state.subscribe ? widget?.querySelector('[data-mb-plan]')?.value : '';
    return {widget,p,state,variant,plan};
  };
  const sync = widget => {
    const {state,variant,plan,p}=selected(widget);
    const allocation=variant.selling_plan_allocations?.find(x=>String(x.selling_plan_id)===String(plan));
    const price=allocation?.price ?? variant.price;
    widget.querySelector('[data-mb-subscription-toggle]')?.setAttribute('aria-checked',String(state.subscribe));
    for (const form of document.querySelectorAll('form[action*="/cart/add"]')) {
      const input=form.querySelector('[name="id"]'); if (input) input.value=variant.id;
      let planInput=form.querySelector('[name="selling_plan"]');
      if (!planInput) {planInput=document.createElement('input');planInput.type='hidden';planInput.name='selling_plan';form.append(planInput);}
      planInput.value=plan||'';planInput.disabled=!plan;
    }
    widget.querySelectorAll('[data-mb-offer]').forEach((bar,index)=>{
      bar.classList.toggle('kaching-bundles__bar--selected',index===state.index);
      const radio=bar.querySelector('input[type="radio"]');if(radio)radio.checked=index===state.index;
      const offer=p.variants[index];
      const offerPrice=offer.selling_plan_allocations?.find(x=>String(x.selling_plan_id)===String(plan))?.price ?? offer.price;
      const displayed=bar.querySelector('[data-mb-price]');if(displayed)displayed.textContent=money(offerPrice);
      const savings=bar.querySelector('[data-mb-savings]');
      if(savings)savings.textContent=offer.compare_at_price>offerPrice ? `${document.documentElement.lang==='es'?'Ahorras':'You save'} ${Math.round((offer.compare_at_price-offerPrice)*100/offer.compare_at_price)}%` : '';
    });
    document.querySelectorAll('.mb-atc-btn-price, [class*="mobile-cta-price-js"]').forEach(node=>node.textContent=money(price));
    document.querySelectorAll('.mb-atc-btn-compare, [class*="mobile-cta-compare-js"]').forEach(node=>{
      node.textContent=variant.compare_at_price>price?money(variant.compare_at_price):'';
    });
    const selectedJson=document.querySelector('variant-selects script[type="application/json"]');
    if(selectedJson)selectedJson.textContent=JSON.stringify(variant);
    document.dispatchEvent(new CustomEvent('kaching:variant:changed',{detail:{variant}}));
  };
  const mutate = async (anchor, operation) => {
    if (busy) return;
    busy=true;anchor?.classList.add('mb-loading');
    try {await operation();await refreshCart(true,anchor);}
    catch(ex){error(ex.message,anchor);}
    finally {busy=false;anchor?.classList.remove('mb-loading');}
  };
  const add = (anchor, index) => mutate(anchor, async()=>{
    const choice=selected(anchor);
    if(Number.isInteger(index))choice.variant=choice.p.variants[index];
    if(!choice.variant?.available)throw new Error('This product is currently unavailable.');
    const item={id:choice.variant.id,quantity:1,properties:bundleProperties(choice.variant)};
    if(choice.plan) {
      if(!choice.variant.selling_plan_allocations?.some(x=>String(x.selling_plan_id)===String(choice.plan))) throw new Error('Please select an available subscription plan.');
      item.selling_plan=Number(choice.plan);
    }
    await request('cart/add.js',{items:[item]});
  });
  document.addEventListener('submit', event => {
    if(event.target.matches('form[action*="/cart/add"]')) {
      event.preventDefault();event.stopImmediatePropagation();add(event.submitter||event.target);
    }
  },true);
  document.addEventListener('click', event => {
    const target=event.target;
    const cartLink=target.closest('#cart-icon-bubble');
    if(cartLink){event.preventDefault();event.stopImmediatePropagation();refreshCart(true,cartLink).catch(ex=>error(ex.message,cartLink));return;}
    const offer=target.closest('[data-mb-offer]');
    if(offer){event.preventDefault();event.stopImmediatePropagation();const w=offer.closest('[data-mb-bundles]');const old=selected(w).state;selections.set(w,{...old,index:Number(offer.dataset.mbOffer)});sync(w);return;}
    const subscription=target.closest('[data-mb-subscription-toggle]');
    if(subscription && !target.closest('select')){event.preventDefault();event.stopImmediatePropagation();const w=subscription.closest('[data-mb-bundles]');const old=selected(w).state;selections.set(w,{...old,subscribe:!old.subscribe});subscription.setAttribute('aria-checked',String(!old.subscribe));sync(w);return;}
    const remove=target.closest('[data-mcd-remove]');
    if(remove){event.preventDefault();event.stopImmediatePropagation();mutate(remove,()=>request('cart/change.js',{id:remove.dataset.key,quantity:0}));return;}
    const tier=target.closest('[data-mcd-tier]');
    if(tier){event.preventDefault();event.stopImmediatePropagation();mutate(tier,async()=>{
      const cart=await request('cart.js');const old=cart.items.find(i=>i.key===tier.dataset.key);
      if(!old||Number(tier.dataset.to)===old.variant_id)return;
      const nextVariant=Object.values(getProducts()).flatMap(p=>p.variants||[]).find(v=>Number(v.id)===Number(tier.dataset.to));
      if(!nextVariant)throw new Error('Please refresh your cart and try again.');
      const item={id:Number(tier.dataset.to),quantity:old.quantity,properties:bundleProperties(nextVariant,old.properties||{})};
      if(tier.dataset.plan)item.selling_plan=Number(tier.dataset.plan);
      await request('cart/add.js',{items:[item]});
      try{await request('cart/change.js',{id:old.key,quantity:0});}
      catch(ex){const after=await request('cart.js');const inserted=after.items.find(i=>i.variant_id===item.id&&i.key!==old.key);if(inserted)await request('cart/change.js',{id:inserted.key,quantity:0});throw ex;}
    });return;}
    const protection=target.closest('[data-fc-sp-toggle]');
    if(protection){event.preventDefault();event.stopImmediatePropagation();mutate(protection,async()=>{
      const cart=await request('cart.js');const p=getProducts()['shipping-protection'];
      const line=cart.items.find(i=>i.handle==='shipping-protection');
      if(line)await request('cart/change.js',{id:line.key,quantity:0});
      else if(p?.variants?.[0]?.available)await request('cart/add.js',{items:[{id:p.variants[0].id,quantity:1}]});
      else throw new Error('Shipping protection is currently unavailable.');
    });return;}
    const pricing=target.closest('button[onclick*="handlePricingAction"]');
    if(pricing){event.preventDefault();event.stopImmediatePropagation();const match=pricing.getAttribute('onclick').match(/handlePricingAction\((\d+)/);add(pricing,Number(match?.[1]||0));return;}
    const mobile=target.closest('button[onclick*="handleMobileCtaAction"]');
    if(mobile){event.preventDefault();event.stopImmediatePropagation();add(mobile);}
  },true);
  document.addEventListener('change', event => {
    const w=event.target.closest('[data-mb-bundles]');if(w)sync(w);
  });
  document.addEventListener('keydown',event=>{
    const target=event.target.closest('[data-mb-subscription-toggle], [data-mb-offer] .kaching-bundles__bar-main');
    if(target&&(event.key==='Enter'||event.key===' ')){event.preventDefault();target.click();}
  });
  const initialize = async () => {
    getProducts();
    const market=JSON.parse(document.querySelector('#mb-localization')?.textContent || '{}');
    for(const form of document.querySelectorAll('localization-form form')) {
      if(!form.querySelector('[name="country_code"]'))continue;
      for(const link of form.querySelectorAll('a[data-value]')) {
        const country=market.countries?.find(c=>c.code===link.dataset.value);
        if(!country){link.closest('li')?.remove();continue;}
        const label=link.querySelector('.country');if(label)label.textContent=country.name;
        const currency=link.querySelector('.localization-form__currency');if(currency)currency.textContent=`${market.currency} $`;
        link.toggleAttribute('aria-current',country.code===market.country);
        link.querySelector('span')?.classList.toggle('visibility-hidden',country.code!==market.country);
      }
      const label=form.querySelector('button.disclosure__button > span');
      if(label)label.textContent=`${market.country_name} | ${market.currency} $`;
    }
    if(document.documentElement.lang==='es')for(const link of document.querySelectorAll('a[href="/a/tracking"]'))link.href=root+'a/tracking';
    for(const w of document.querySelectorAll('[data-mb-bundles]')) {
      const p=getProducts()[w.dataset.productHandle];if(!p?.variants?.length)continue;
      const state={index:Math.min(1,p.variants.length-1),subscribe:!!w.querySelector('[data-mb-plan]')};
      try {
        const response=await fetch(w.dataset.configUrl);const c=await response.json();
        w.querySelector('[data-mb-block-title]').textContent=c.blockTitle;
        c.dealBars?.forEach((bar,index)=>{
          const el=w.querySelector(`[data-mb-offer="${index}"]`);if(!el)return;
          el.querySelector('[data-mb-title]').textContent=bar.title;
          const badge=el.querySelector('[data-mb-badge]');if(badge)badge.textContent=bar.badgeText;
          if(bar.id===c.preselectedDealBarId)state.index=index;
        });
        if(c.subscriptions){state.subscribe=!!c.subscriptions.subscribeByDefault&&!!w.querySelector('[data-mb-plan]');const title=w.querySelector('[data-mb-subscribe-title]');const subtitle=w.querySelector('[data-mb-subscribe-subtitle]');if(title)title.textContent=c.subscriptions.subscribeTitle;if(subtitle)subtitle.textContent=c.subscriptions.subscribeSubtitle;}
      } catch {}
      selections.set(w,state);sync(w);
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
})();

// Native full-page cart quantities preserve selling plans through Shopify’s cart form.
document.addEventListener("change", event => { const form = event.target.closest("form[data-mb-native-cart]"); if (form && event.target.matches("input[name=\"updates[]\"]")) form.requestSubmit(); });
